import React from "react";

const BS5_Range = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_Range Component</h2>
      <p>This is the BS5_Range component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_Range;
